export const OnlineServices = {
  en: {
    'Online Services': 'Online Services',
    Position: 'Position',
    Name: 'Name',
    Active: 'Active',
    Subscription: 'Subscription',
    Price: 'Price',
    'Create Online Service': 'Create Online Service',
    'Extra price': 'Extra price',
    'Discount or extra price for the first month of subscription':
      'Discount or extra price for the first month of subscription',
    'Online Payment Key': 'Online Payment Key',
  },
  uk: {
    'Online Services': 'Онлайн Сервіси',
    Name: 'Назва',
    Active: 'Активний',
    Subscription: 'Підписка',
    Price: 'Ціна',
    'Create Online Service': 'Створити онлайн сервіс',
    Position: 'Позиція',
    'Extra price': 'Додаткова ціна',
    'Discount or extra price for the first month of subscription':
      'Знижка або доплата за перший місяць підписки',
    'Online Payment Key': 'Платіжний ключ',
  },
};

export const OnlineServiceForm = {
  en: {
    ...OnlineServices.en,
    'New Online Service': 'New Online Service',
    'Edit Online Service': 'Edit Online Service',
    'Update Online Service': 'Update Online Service',
    'Total Price': 'Total Price',
    Description: 'Description',
    UAH: 'UAH',
    'Online Payment Key': 'Online Payment Key {{key_type}}',
    'Subscription requires a LiqPay key': 'Subscription requires a LiqPay key',
    'Start payment required': 'Start payment required',
    'Start service': 'Start service',
    'Days for resubscribe': 'Days for resubscribe',
    'At least one payment key must be selected':
      'At least one payment key must be selected',
    'Choose services for the online service':
      'Choose services for the online service',
  },
  uk: {
    ...OnlineServices.uk,
    'New Online Service': 'Новий Онлайн Сервіс',
    'Edit Online Service': 'Редагування Онлайн Сервісу',
    'Update Online Service': 'Оновити Онлайн Сервіс',
    'Total Price': 'Загальна сума',
    Description: 'Опис',
    UAH: 'грн.',
    'Online Payment Key': 'Платіжний ключ {{key_type}}',
    'Subscription requires a LiqPay key': 'Для підписки потрібен LiqPay ключ',
    'Start payment required': 'Додати стартовий платіж',
    'Start service': 'Стартовий сервіс',
    'Days for resubscribe': 'Днів для повторної підписки',
    'At least one payment key must be selected':
      'Необхідно вибрати хоча б один платіжний ключ',
    'Choose services for the online service':
      'Виберіть сервіси для онлайн сервісу',
  },
};
